import { API_URL } from '@/consts/urls';
import { getContext } from '@/context';

const fetchUserTier = async () => {
  try {
    const response = await getContext().utils.api.fetch(
      `${API_URL}/guard/users/tier`
    );
    return await response.json();
  } catch {
    return null;
  }
};

export { fetchUserTier };
